"use client";

import { FormSection } from "@/types";
import { RichText } from "@/components/StrapiComponents/RichText";
import WufooForm from "./WofooForm";
import { useEffect, useState } from "react";

import "@/styles/Cookies.scss";

export const FormSectionComponent = ({ content }: { content: FormSection }) => {
	const [isVisible, setIsVisible] = useState<boolean>(false);

	useEffect(() => {
		const storedConsent = localStorage.getItem("cookieConsent");
		if (storedConsent) {
			setIsVisible(true);
		}
	}, []);

	useEffect(() => {
		const handleConsent = () => {
			setIsVisible(true);
		};

		window.addEventListener("cookieAccepted", handleConsent);

		return () => {
			window.removeEventListener("cookieAccepted", handleConsent);
		};
	}, []);

	const handleAccept = () => {
		window.dispatchEvent(new Event("cookie-form-accepted"));
		setIsVisible(true);
	};

	return (
		<section className="section-wrapper --no-padding-bottom" id="form">
			<div className="max-wrapper">
				{!isVisible && (
					<div className="cookie-box">
						<p>
							Bitte akzeptiere die Cookies um das Formular anzuzeigen. <br />
							<i>Please accept the cookies to display the form.</i>{" "}
						</p>
						<button className="" onClick={() => handleAccept()}>
							Cookies akzeptieren
						</button>
					</div>
				)}
				{isVisible && (
					<>
						{content.content && <RichText content={content.content} />}

						{content.formHash && content.userName && (
							<div className="margin-top">
								<WufooForm formHash={content.formHash} userName={content.userName} />
							</div>
						)}
					</>
				)}
			</div>
		</section>
	);
};
